// TurfAI Configuration Service
// Connects to platform

export const turfaiConfig = {
  dms: {
    url: import.meta.env.VITE_TURFAI_DMS_URL || 'http://localhost:1338',
    apiUrl: import.meta.env.VITE_TURFAI_API_URL || 'http://localhost:1338/api',
  },
  auth: {
    // Test credentials for development
    testEmail: import.meta.env.VITE_TURFAI_TEST_EMAIL || 'turfai@openturf.in', 
    testPassword: import.meta.env.VITE_TURFAI_TEST_PASSWORD || 'turf123@!',
    // API key for dual authentication (temporary for testing)
    apiKey: import.meta.env.VITE_TURFAI_API_KEY || '', // Will be provided separately
  },
  workflow: {
    id: import.meta.env.VITE_TURFAI_WORKFLOW_ID || '', // Activity ID resolved dynamically from workflow registry
    // Public API endpoints (different from standard Strapi format)
    executeEndpoint: '/workflow-executions/public/execute',
    statusEndpoint: '/workflow-executions/public',
  },
  onboarding: {
    requiredDocuments: (import.meta.env.VITE_REQUIRED_DOCUMENTS || 'pan_card,aadhar_card').split(','),
    validationThreshold: parseFloat(import.meta.env.VITE_VALIDATION_THRESHOLD || '0.8'),
    autoApproveThreshold: parseFloat(import.meta.env.VITE_AUTO_APPROVE_THRESHOLD || '0.95'),
    enableAutoDetection: import.meta.env.VITE_ENABLE_AUTO_DETECTION === 'true',
  },
  ui: {
    enableRealTimeProcessing: import.meta.env.VITE_ENABLE_REAL_TIME_PROCESSING !== 'false',
    pollingInterval: parseInt(import.meta.env.VITE_POLLING_INTERVAL || '2000'),
    maxFileSize: parseInt(import.meta.env.VITE_MAX_FILE_SIZE || '10485760'), // 10MB
    supportedFormats: (import.meta.env.VITE_SUPPORTED_FORMATS || 'pdf,jpg,jpeg,png').split(','),
  }
};

// Document type mapping for Indian identity documents
export const DOCUMENT_TYPE_MAPPING: Record<string, string> = {
  'pan_card': 'PAN Card',
  'aadhar_card': 'Aadhar Card',
  'passport': 'Passport',
  'driving_license': 'Driving License',
  'bank_statement': 'Bank Statement',
  'offer_letter': 'Offer Letter',
  'voter_id': 'Voter ID',
  'degree_certificate': 'Degree Certificate',
  'experience_letter': 'Experience Letter',
  'salary_slip': 'Salary Slip',
};

// Reverse mapping for display names to keys
export const DOCUMENT_TYPE_KEYS: Record<string, string> = Object.entries(DOCUMENT_TYPE_MAPPING)
  .reduce((acc, [key, value]) => ({ ...acc, [value]: key }), {});

// Helper function to detect document type from filename
export const detectDocumentType = (filename: string): string => {
  const lowerName = filename.toLowerCase();
  
  if (lowerName.includes('pan')) return 'pan_card';
  if (lowerName.includes('aadhar') || lowerName.includes('aadhaar')) return 'aadhar_card';
  if (lowerName.includes('passport')) return 'passport';
  if (lowerName.includes('license') || lowerName.includes('licence')) return 'driving_license';
  if (lowerName.includes('bank') || lowerName.includes('statement')) return 'bank_statement';
  if (lowerName.includes('offer')) return 'offer_letter';
  if (lowerName.includes('voter') || lowerName.includes('vote')) return 'voter_id';
  if (lowerName.includes('degree') || lowerName.includes('certificate')) return 'degree_certificate';
  if (lowerName.includes('experience')) return 'experience_letter';
  if (lowerName.includes('salary') || lowerName.includes('slip')) return 'salary_slip';
  
  return 'other';
};

// Validation helpers
export const isValidFileSize = (size: number): boolean => {
  return size <= turfaiConfig.ui.maxFileSize;
};

export const isValidFileFormat = (filename: string): boolean => {
  const extension = filename.split('.').pop()?.toLowerCase() || '';
  return turfaiConfig.ui.supportedFormats.includes(extension);
};

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};